import { render, staticRenderFns } from "./SearchProductsModal.vue?vue&type=template&id=0de2c45e&scoped=true&"
import script from "./SearchProductsModal.vue?vue&type=script&lang=js&"
export * from "./SearchProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductsModal.vue?vue&type=style&index=0&id=0de2c45e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de2c45e",
  null
  
)

export default component.exports